<template>
  <v-row no-gutters class="pa-10 full-height">
    <v-col cols="12" sm="8" md="7" lg="5" xl="4">
      <v-row justify="start" class="ml-2">
        <Icon
          name="crownrewards"
          :color="$vuetify.theme.themes.light.secondary"
          :style="{
            height: '35px',
            width: '35px',
          }"
        ></Icon>
        <span class="secondary--text font-weight-bold text-h6"
          >YOUR STORE REWARDS</span
        >
      </v-row>
      <v-row class="full-height" v-if="$vuetify.breakpoint.smAndUp">
        <v-col class="full-height" v-if="hasPoints">
          <div class="tab full-height">
            <div class="dot">
              <Icon
                name="crownrewards"
                :color="$vuetify.theme.themes.light.primary"
                :style="{
                  height: '55px',
                  width: '55px',
                  position: 'absolute',
                  bottom: '145px',
                  transform: 'rotate(-20deg)',
                  'margin-right': '40px',
                }"
              ></Icon>
              <span class="EARN-BACK-On-Every-Purchase primary--text">
                EARN BACK

                <span class="text-style-2" style="display: block"
                  >On Every</span
                >
                <span class="text-style-2" style="display: block"
                  >Purchase</span
                >
              </span>
            </div>
            <p class="Store-Points pt-3 text-center">Store Points</p>
          </div>
        </v-col>
        <v-col class="full-height" v-if="hasClubs">
          <div class="tab full-height">
            <div class="dot">
              <Icon
                name="crownrewards"
                :color="$vuetify.theme.themes.light.secondary"
                :style="{
                  height: '55px',
                  width: '55px',
                  position: 'absolute',
                  bottom: '145px',
                  transform: 'rotate(-20deg)',
                  'margin-right': '40px',
                  'margin-top': '40px',
                }"
              ></Icon>
              <span class="EARN-BACK-On-Every-Purchase secondary--text">
                CLUBS
                <span class="text-style-3" style="display: block">REWARDS</span>

                <span class="text-style-2" style="display: block">Buy X,</span>
                <span class="text-style-2" style="display: block"
                  >Get 1 Free</span
                >
              </span>
            </div>
            <p class="Store-Points pt-3 text-center">Store Clubs</p>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="pt-16" cols="12" sm="4" md="5" lg="7" xl="8">
      <v-row align="center" justify="center" class="full-height">
        <v-col class="d-flex flex-column align-center" cols="12" sm="7">
          <p class="text-h6 text-center" style="">Log In to View Rewards</p>
          <!-- @click="toAuthRoute('signup')" -->
          <v-btn
            class="mb-4"
            color="primary"
            @click.stop="toLogin()"
            block
            large
            rounded
          >
            <div class="font-size-md font-weight-semibold text-capitalize">
              LOG IN
            </div>
          </v-btn>
          <p style="font-size: 13px" class="secondary--text text-center">
            <span>Don't have an account? </span>
            <span
              style="text-wrap: nowrap"
              @click.stop="toSignUp()"
              class="secondary--text text-decoration-underline"
              >Sign Up Here!</span
            >
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Icon from "@/components/UI/Icon.vue";
import { mapGetters } from "vuex";

export default {
  name: "RewardsBeforeAuth",
  components: { Icon },
  computed: {
    ...mapGetters("store", { hasPoints: "hasPoints", hasClubs: "hasClubs" }),
  },
  methods: {
    openLoginDialog() {
      this.$store.commit("auth/OPEN", true);
    },
    routeToLoginView() {
      this.$router.push({ name: "login" });
    },
    toLogin() {
      this.$vuetify.breakpoint.xsOnly
        ? this.routeToLoginView()
        : this.openLoginDialog();
    },
    toSignUp() {
      this.$store.commit("auth/SET_ACTIVE_COMPONENT", "signup");
      this.openLoginDialog();
    },
  },
};
</script>

<style scoped>
.tab {
  background-color: #f5f5f5;
  border-radius: 8px;
  position: relative;
  justify-content: end;
  height: 230px;
}
.dot {
  height: 110px;
  width: 110px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Store-Points {
  font-size: 18px;
  line-height: 1.1;

  text-align: center;
}
.EARN-BACK-On-Every-Purchase {
  font-size: 24px;
  font-weight: 900;
  line-height: 0.95;
  letter-spacing: -0.72px;
  text-align: center;
}
.EARN-BACK-On-Every-Purchase .text-style-2 {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.42px;
}
.EARN-BACK-On-Every-Purchase .text-style-3 {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: -0.42px;
}
</style>
